import { supabase } from './auth';
import { WorkoutData } from '../types';

export interface ManualActivity {
  id: string;
  user_id: string;
  activity_date: string; // ISO date
  type: string;
  duration_minutes: number;
  distance_miles: number | null;
  intensity: 'low' | 'moderate' | 'high';
  notes: string | null;
  created_at?: string;
}

export const listRecentActivities = async (days = 7): Promise<ManualActivity[]> => {
  const since = new Date(Date.now() - days * 86400000).toISOString().split('T')[0];
  const { data, error } = await supabase
    .from('activities')
    .select('*')
    .gte('activity_date', since)
    .order('activity_date', { ascending: false });

  if (error) throw error;
  return (data ?? []) as ManualActivity[];
};

export const logActivity = async (activity: {
  activity_date: string;
  type: string;
  duration_minutes: number;
  distance_miles: number | null;
  intensity: 'low' | 'moderate' | 'high';
  notes?: string | null;
}): Promise<ManualActivity> => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not signed in');

  const { data, error } = await supabase
    .from('activities')
    .insert([{ ...activity, user_id: user.id }])
    .select()
    .single();

  if (error) throw error;
  return data as ManualActivity;
};

export const deleteActivity = async (id: string): Promise<void> => {
  const { error } = await supabase.from('activities').delete().eq('id', id);
  if (error) throw error;
};

/** Convert manual entries to the WorkoutData shape used everywhere else. */
export const activitiesToWorkouts = (activities: ManualActivity[]): WorkoutData[] =>
  activities.map((a) => ({
    id: `manual-${a.id}`,
    duration: a.duration_minutes * 60,
    intensity: a.intensity,
    type: a.type,
    timestamp: `${a.activity_date}T12:00:00`,
    distance: a.distance_miles ? a.distance_miles * 1609.34 : undefined,
  }));
